
import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

import moment from 'moment'
import momentLocaliser from 'react-widgets/lib/localizers/moment'

const headers = {'Content-Type': 'application/json'}

export function getLocationDataDefaultFromServer(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For favHotelsNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(getFavHotelsBegin())
        //const url = 'http://localhost:8080/essearch/favouritehotels'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/favouritehotels`

        const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                if(r.data.locationData){
                   
                    const comData = r.data.locationData
                    const {startDate, endDate, hotels }= comData
                     let  momIsoStartDate = moment(startDate);
                     let  momIsoEndDate = moment(endDate);
                    comData['startDate'] = momIsoStartDate
                    comData['endDate'] = momIsoEndDate
                    let items = []
                    if(hotels){
                        
                        
                        hotels.forEach( (ob, i)=>{
                            items.push(ob['label'])
         
                        })
         
                 }
                
                 comData['dataSourceSV'] = items

                   
                    let newlocationData = { locationData : comData}
                    dispatch(getFavHotelsSuccess(newlocationData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getFavHotelsSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getFavHotelsError(e))
        )
    }

}


export const getFavHotelsBegin = () => dispatch => {
    dispatch({
        type:"fav/SOJOURNS_BEGIN"
        
    })
}

export const getFavHotelsSuccess = (data) => dispatch => {
    dispatch({
        type: "fav/SOJOURNS_SUCCESS",
        payload: data
    })
}



export const getFavHotelsError = (e) =>dispatch => {
    dispatch({
        type:"fav/SOJOURNS_ERROR",
        error:e
    })
}



export function esautocompleteNow(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For esautocompleteNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(esautocompleteBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojListForAutoComplete`
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                if(r.data.esTAResults){
                   
                    const comData = r.data.esTAResults

                    let newacData = { esacList : comData}
                    

                   
                    dispatch(esautocompleteSuccess(newacData))
                }
                else {
                    const comData = []
                    let newacData = { esacList : comData}
                    dispatch(esautocompleteSuccess(newacData))
                }
            }
        ).catch(
            e=>dispatch(esautocompleteError(e))
        )
    }

}




export const esautocompleteBegin = () => dispatch => {
    dispatch({
        type:"fav/ESAC_BEGIN"
        
    })
}

export const esautocompleteSuccess = (data) => dispatch => {
    dispatch({
        type: "fav/ESAC_SUCCESS",
        payload: data
    })
}



export const esautocompleteError = (e) =>dispatch => {
    dispatch({
        type:"fav/ESAC_ERROR",
        error:e
    })
}
